/* eslint-disable no-useless-escape */
import { parse } from 'querystring';
import dayjs from 'dayjs';

const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = (path: string): boolean => reg.test(path);

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

export const formatMoney = (value: number | string): string => {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    if (numberValue == null || Number.isNaN(numberValue)) return '$ 0,00';
    return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numberValue);
};

export const formatDateTime = (value?: string | null): string =>
    value ? `${dayjs(value).format('DD/MM/YYYY HH:mm')}hs` : '-';

export const normalizeResults = (data: any) => (Array.isArray(data) ? data : data?.results || []);

export const normalizeCount = (data: any): number => (Array.isArray(data) ? data.length : data?.count || 0);

export function isProdEnviroment(): boolean {
    return APP_ENV === 'prod';
}

export function isQaEnviroment(): boolean {
    return APP_ENV === 'qa';
}